var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "nav-link",
      attrs: {
        href: _vm.urlWishList,
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _c("span", { staticClass: "badge-right mr-1 d-none d-sm-inline" }, [
        _vm._v(_vm._s(_vm.wishListCount)),
      ]),
      _vm._v(" "),
      !_vm.wishListCount
        ? _c(
            "svg",
            {
              staticClass: "svg-inline--fa fa-heart",
              attrs: {
                "aria-hidden": "true",
                focusable: "false",
                "data-prefix": "fal",
                "data-icon": "heart",
                role: "img",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "currentColor",
                  d: "M462.3 62.71c-54.5-46.5-136.1-38.99-186.6 13.27l-19.69 20.61l-19.71-20.61C195.6 33.85 113.3 8.71 49.76 62.71C-13.11 116.2-16.31 212.5 39.81 270.5l193.2 199.7C239.3 476.7 247.8 480 255.9 480c8.25 0 16.33-3.25 22.58-9.751l193.6-199.8C528.5 212.5 525.1 116.2 462.3 62.71zM449.3 248.2l-192.9 199.9L62.76 248.2C24.39 208.7 16.39 133.2 70.51 87.09C125.3 40.21 189.8 74.22 213.3 98.59l42.75 44.13l42.75-44.13c23.13-24 88.13-58 142.8-11.5C495.5 133.1 487.6 208.6 449.3 248.2z",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.wishListCount
        ? _c(
            "svg",
            {
              staticClass: "svg-inline--fa fa-heart",
              attrs: {
                "aria-hidden": "true",
                focusable: "false",
                "data-prefix": "fad",
                "data-icon": "heart",
                role: "img",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
              },
            },
            [
              _c("g", { staticClass: "fa-duotone-group" }, [
                _c("path", {
                  staticClass: "fa-secondary",
                  attrs: {
                    fill: "currentColor",
                    d: "M472.1 270.5l-193.1 199.7c-12.64 13.07-33.27 13.08-45.91 .0107l-193.2-199.7C-16.21 212.5-13.1 116.7 49.04 62.86C103.3 15.88 186.4 24.42 236.3 75.98l19.7 20.27l19.7-20.27c49.95-51.56 132.1-60.1 187.3-13.12C525.1 116.6 528.2 212.5 472.1 270.5z",
                  },
                }),
                _c("path", {
                  staticClass: "fa-primary",
                  attrs: { fill: "currentColor", d: "" },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }